// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterSection_root___en7B","header":"FilterSection_header__gpIgA","body":"FilterSection_body__aIeJo","description":"FilterSection_description__WqLam"};